import request from '@/utils/request'

/**
 * 填充师徒关系
 * @param data
 * @returns {*}
 */
export function mentoringRelationshipFill(data) {
    return request({
        url: `/api/MentoringRelationship/mentoringRelationshipFill`,
        method: 'post',
        data: data
    })
}

/**
 * 根据师傅的工号查询其所有的徒弟
 * @param empNo
 * @returns {*}
 */
export function getApprentice(empNo) {
    return request({
        url: `/api/MentoringRelationship/getApprentice?empNo=${empNo}`,
        method: 'get',
    })
}


/**
 *
 * @param empNos
 * @returns {*}
 */
export function isFirstCommercialShop(empNos) {
    return request({
        url: `/api/MentoringRelationship/isFirstCommercialShop`,
        method: 'post',
        data:empNos
    })
}

// =======================================================住宅部=========================================================
/**
 * 填充徒弟
 * @param apprentReq
 * @return {*}
 */
export function apprenticeFill(apprentReq){
    return request({
        url: `/api/MentoringRelationship/weixinApplyInsert`,
        method: 'post',
        data: apprentReq
    })
}

/**
 * 获取师傅的徒弟数，及上限值
 * @param empNo
 */
export function getApprentNumber(empNo){
    return request({
        url: `/api/MentoringRelationship/apprenticeNum?empNo=${empNo}`,
        method: 'get',
    })
}
export function getCheckApprentNumber(empNos) {
    return request({
        url: `/api/MentoringRelationship/checkApprenticeEmpNos`,
        method: 'post',
       /* dataType: 'json',*/
        data: empNos,
    })
}